<template>
  <div class="app-loader-container">
    <div class="app-loader-spinner">
      <base-icon
        iconRef="loader"
        :spinning="true"
      />
    </div>
    <div class="app-loader-message">
      <p>Sonar is aan het laden...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading-spinner"
};
</script>


// WEBPACK FOOTER //
// src/components/LoaderSpinner.vue